<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="my-md-4 pa-4">
            <v-toolbar flat color="#1d2735" dark style="border-radius: 5px">
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <pre><v-toolbar-title><h2>{{ $route.meta.title }}</h2></v-toolbar-title></pre>
            </v-toolbar>

            <router-link to="lista-facturas-entrante">
                <v-btn color="red" class="white--text my-3" s> Volver </v-btn>
            </router-link>

            <v-form ref="linea_form">
                <v-card style="min-width: 100%; padding: 1rem">
                    <h3>Datos generales</h3>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="3" v-if="factura.id != null">
                                <VTextField
                                    v-model="factura.system_number"
                                    label="Nº de factura"
                                    outlined
                                    disabled
                                    hint="Nº de factura único generado automáticamente"
                                    persistent-hint
                                    dense
                                ></VTextField>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    label="Nº de factura proveedor"
                                    v-model="factura.nro_proveedor"
                                    outlined
                                    hint="Nº de factura emitida por el proveedor"
                                    persistent-hint
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <date-select
                                    v-model="factura.fecha"
                                    label="Fecha de emisión"
                                    outlined
                                    dense
                                    hint="Fecha de emisión del proveedor"
                                    persistent-hint
                                >
                                </date-select>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <h3>Datos proveedor</h3>
                    <v-card-text>
                        <v-row align="center">
                            <v-col cols="12" md="4">
                                <dynamicSelectVue
                                    ref="dynamicSelectProveedor"
                                    title="Proveedor"
                                    v-model="factura.id_proveedor"
                                    max-width="800px"
                                    outlined
                                    @create="saveProveedor"
                                    @delete="deleteProveedor"
                                    @getEstado="getProveedorId"
                                    @update="saveProveedor"
                                    @changeElement="changeProveedor"
                                    @getItem="clearProveedor"
                                >
                                    <v-form
                                        ref="formProveedor"
                                        v-model="validFormProveedor"
                                    >
                                        <v-row class="mt-3">
                                            <v-col cols="12" md="6">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.nombre"
                                                    label="Nombre"
                                                    :rules="[rules.required]"
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field
                                                    outlined
                                                    v-model="
                                                        proveedor.nombre_fiscal
                                                    "
                                                    label="Nombre fiscal"
                                                    required
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.cif"
                                                    label="CIF"
                                                    required
                                                    dense
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.email"
                                                    label="Email"
                                                    required
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.telefono"
                                                    label="Teléfono"
                                                    required
                                                    :rules="[rules.phone_rule]"
                                                    dense
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="8">
                                                <v-text-field
                                                    outlined
                                                    label="Dirección"
                                                    v-model="
                                                        proveedor.direccion
                                                    "
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.cp"
                                                    label="CP"
                                                    required
                                                    :rules="[rules.number_rule]"
                                                    dense
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="
                                                        proveedor.poblacion
                                                    "
                                                    label="Población"
                                                    required
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-autocomplete
                                                    outlined
                                                    v-model="
                                                        proveedor.provincia
                                                    "
                                                    label="Provincia"
                                                    required
                                                    :items="provincias"
                                                    item-text="nombre"
                                                    item-value="nombre"
                                                    dense
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.pais"
                                                    label="País"
                                                    required
                                                    dense
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="12">
                                                <v-textarea
                                                    outlined
                                                    v-model="
                                                        proveedor.observaciones
                                                    "
                                                    label="Observaciones"
                                                    dense
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </dynamicSelectVue>
                            </v-col>
                            <v-col cols="12" md="4">
                                <proveedoresSelectVue
                                    v-model="factura.proveedor.id"
                                    label="Nombre fiscal"
                                    outlined
                                    dense
                                    :extra="factura.proveedor"
                                    item-text="nombre_fiscal"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <proveedoresSelectVue
                                    v-model="factura.proveedor.id"
                                    label="CIF"
                                    outlined
                                    dense
                                    :extra="factura.proveedor"
                                    item-text="cif"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <proveedoresSelectVue
                                    v-model="factura.proveedor.id"
                                    label="Teléfono"
                                    outlined
                                    dense
                                    :extra="factura.proveedor"
                                    item-text="telefono"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field
                                    label="Dirección"
                                    outlined
                                    disabled
                                    v-model="factura.proveedor.direccion"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Código Postal"
                                    outlined
                                    disabled
                                    v-model="factura.proveedor.cp"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    label="Provincia"
                                    outlined
                                    disabled
                                    v-model="factura.proveedor.provincia"
                                    :items="provincias"
                                    item-text="nombre"
                                    item-value="nombre"
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Población"
                                    outlined
                                    disabled
                                    v-model="factura.proveedor.poblacion"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <div class="d-flex align-center gap-3">
                        <h3 class="mr-2">Datos de línea</h3>
                        <v-btn-toggle
                            color="primary"
                            shaped
                            v-model="tipo_linea"
                            background-color="white"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn text v-bind="attrs" v-on="on">
                                        <v-icon>mdi-keyboard-variant</v-icon>
                                    </v-btn>
                                </template>
                                <span>Manual</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn text v-bind="attrs" v-on="on">
                                        <v-icon>mdi-playlist-check</v-icon>
                                    </v-btn>
                                </template>
                                <span>Albarán de compra</span>
                            </v-tooltip>
                        </v-btn-toggle>
                    </div>

                    <v-card-text>
                        <v-row>
                            <template v-if="tipo_linea == 0">
                                <v-col cols="12" md="3">
                                    <v-autocomplete
                                        v-model="selectedProductoCompraLinea"
                                        :items="productos_compra_busqueda"
                                        :search-input.sync="searchProductoCompra"
                                        label="Producto de compra (buscar por código o nombre)"
                                        item-text="nombre"
                                        item-value="id"
                                        return-object
                                        clearable
                                        hide-no-data
                                        :loading="loadingProductosCompra"
                                        @change="onProductoCompraSelect"
                                        @focus="onFocusProductoCompra"
                                        dense
                                        outlined
                                    >
                                        <template v-slot:item="{ item }">
                                            <span class="font-weight-medium">{{ item.codigo || '—' }}</span>
                                            — {{ item.nombre }} ({{ formatPrice(item.precio) }}€)
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <span v-if="item">{{ item.codigo || '' }} {{ item.nombre }}</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field
                                        v-model="linea.descripcion"
                                        label="Descripción"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                    >
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" md="1">
                                    <div class="spacing">
                                        <v-text-field-comma
                                            v-model="linea.cantidad"
                                            type="number"
                                            label="Cantidad"
                                            :rules="[rules.required, rules.min]"
                                        >
                                        </v-text-field-comma>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="1">
                                    <div class="spacing">
                                        <v-text-field-comma
                                            v-model="linea.precio"
                                            type="number"
                                            label="Precio"
                                            :rules="[rules.required, rules.min]"
                                        >
                                        </v-text-field-comma>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="1">
                                    <v-autocomplete
                                        v-model="linea.iva_id"
                                        label="IVA"
                                        :items="ivas"
                                        item-text="descripcion"
                                        item-value="id"
                                        suffix="%"
                                        :rules="[rules.required]"
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <div style="display: flex">
                                        <v-text-field-comma
                                            v-model="linea.dcto"
                                            type="number"
                                            label="Descuento"
                                        >
                                        </v-text-field-comma>
                                        <v-btn-toggle
                                            color="primary"
                                            shaped
                                            v-model="linea.tipo_dcto"
                                            background-color="white"
                                        >
                                            <v-btn text>
                                                <v-icon>mdi-percent</v-icon>
                                            </v-btn>
                                            <v-btn text>
                                                <v-icon
                                                    >mdi-currency-eur</v-icon
                                                >
                                            </v-btn>
                                        </v-btn-toggle>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-btn
                                        @click="addLinea()"
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text"
                                    >
                                        Añadir
                                    </v-btn>
                                </v-col>
                            </template>
                            <template v-else>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="factura.albaranes"
                                        :items="albaranes"
                                        chips
                                        multiple
                                        label="Albaranes"
                                        item-text="nro"
                                        item-value="id"
                                        @change="getAlbaran"
                                    >
                                        <!-- Personalizar las opciones desplegables -->
                                        <template v-slot:item="data">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span
                                                        >Número:
                                                        {{
                                                            data.item.nro
                                                        }}</span
                                                    >
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    <span
                                                        >Fecha:
                                                        {{
                                                            data.item.fecha
                                                                | format_date
                                                        }}</span
                                                    >
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle>
                                                    <span
                                                        >Importe:
                                                        {{
                                                            data.item.importe
                                                                | format_precio
                                                        }}</span
                                                    >
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>

                                        <!-- Personalizar los elementos seleccionados -->
                                        <template v-slot:selection="data">
                                            <v-chip
                                                class="ma-2"
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                close
                                                @click:close="remove(data.item)"
                                            >
                                                {{ data.item.nro }}/{{
                                                    data.item.fecha
                                                        | format_date
                                                }}/{{
                                                    data.item.importe
                                                        | format_precio
                                                }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card style="min-width: 100%; padding: 1rem">
                    <h3 style="margin-top: 10px">Líneas de la factura</h3>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                dense
                                :headers="headers"
                                hide-default-footer
                                disable-pagination
                                :items="factura.lineas"
                                item-key="id"
                                class="elevation-1"
                            >
                                <template v-slot:item.cantidad="{ item }">
                                    {{ item.cantidad | decimalComma }}
                                </template>
                                <template v-slot:item.precio="{ item }">
                                    {{ formatPrice(item.precio) }}
                                </template>
                                <template v-slot:item.dcto="{ item }">
                                    {{ formatPrice(item.dcto) }}
                                </template>
                                <template v-slot:item.subtotal="{ item }">
                                    {{ formatPrice(item.subtotal) }}
                                </template>
                                <template v-slot:item.total="{ item }">
                                    {{ formatPrice(item.total) }}
                                </template>
                                <template v-slot:item.dcto_total="{ item }">
                                    {{ formatPrice(CalcularTotalDcto(item)) }}
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                        @click="openEditDialog(item)"
                                        small
                                        class="mr-2"
                                        color="black"
                                        style="font-size: 25px"
                                        title="EDITAR"
                                        >mdi-pencil-outline</v-icon
                                    >

                                    <v-icon
                                        @click="openDeleteDialog(item)"
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 25px"
                                        title="BORRAR"
                                        >mdi-trash-can</v-icon
                                    >
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-row align="center" justify="end">
                        <v-col cols="8" class="d-flex justify-center">
                            <div class="d-flex flex-column justify-center">
                                <v-text-field-comma
                                    v-model.number="factura.porcentaje_retencion"
                                    label="% Retención IRPF"
                                    type="number"
                                    outlined
                                    dense
                                    suffix="%"
                                    hint="El importe se calculará automáticamente"
                                    persistent-hint
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    style="max-width: 200px"
                                ></v-text-field-comma>
                                <h3 class="mb-3 mr-2 mt-4">Fechas de vencimiento</h3>
                                <v-text-field
                                    label="Plazos de pago"
                                    v-model="factura.plazos_pago"
                                    outlined
                                    hint="Cantidad de pagos a realizar para el total de la factura"
                                    persistent-hint
                                    type="number"
                                    dense
                                    style="max-width: 200px"
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card style="min-width: 100%; padding: 1rem">
                                <v-row>
                                    <v-col cols="6">
                                        <h4>Subtotal:</h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>
                                            {{ formatPrice(subtotal) }}
                                            €
                                        </h4>
                                    </v-col>
                                    <template v-for="(total, tipoIva) in iva">
                                        <v-col cols="6" :key="tipoIva">
                                            <h4>IVA {{ tipoIva }}%:</h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>
                                                {{ formatPrice(total) }}
                                                €
                                            </h4>
                                        </v-col>
                                    </template>
                                    <v-col cols="6" v-if="factura.importe_retencion > 0">
                                        <h4>Retención IRPF:</h4>
                                    </v-col>
                                    <v-col cols="6" v-if="factura.importe_retencion > 0">
                                        <h4 style="color: red; font-weight: bold">
                                            -{{ formatPrice(factura.importe_retencion) }}
                                            €
                                        </h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>Total con IVA:</h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>
                                            {{ formatPrice(total) }}
                                            €
                                        </h4>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <template
                            v-for="(item, index) in factura.fecha_vencimiento"
                        >
                            <v-col cols="3" :key="index">
                                <date-select
                                    :label="
                                        'Fecha de vencimiento ' + (index + 1)
                                    "
                                    v-model="item.fecha"
                                    outlined
                                    dense
                                ></date-select>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field-comma
                                    :label="'Importe ' + (index + 1)"
                                    v-model="item.importe"
                                    outlined
                                    dense
                                    suffix="€"
                                    type="number"
                                ></v-text-field-comma>
                            </v-col>
                        </template>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="factura.observaciones"
                                label="Obersevaciones"
                                outlined
                            >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="factura.observaciones_internas"
                                label="Obersevaciones internas"
                                outlined
                            >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <MetodosDePagoSelect
                                v-model="factura.id_metodo_pago"
                            />
                        </v-col>
                    </v-row>
                </v-card>

                <v-row style="margin-top: 10px">
                    <v-col cols="12">
                        <router-link to="lista-facturas-entrante">
                            <v-btn color="red" class="white--text mr-2">
                                Cancelar
                            </v-btn>
                        </router-link>
                        <v-btn
                            v-if="!factura.id"
                            @click="saveFactura"
                            :disabled="isloading"
                            color="success"
                            class="white--text mr-2"
                            >Guardar</v-btn
                        >
                        <v-btn
                            v-if="factura.id"
                            @click="saveFactura"
                            :disabled="isloading"
                            color="success"
                            class="white--text mr-2"
                            >Actualizar</v-btn
                        >
                        <v-btn
                            v-if="factura.id"
                            @click="openAsiento"
                            color="success"
                            class="white--text mr-2"
                            >Abrir asiento</v-btn
                        >
                        <router-link
                            :to="{
                                path: `/lista-abonos-entrantes?id=${factura.id}`,
                            }"
                        >
                            <v-btn
                                v-if="factura.id"
                                :disabled="isloading"
                                color="blue"
                                class="white--text"
                                >Abonos</v-btn
                            >
                        </router-link>
                    </v-col>
                </v-row>
            </v-form>
        </v-card>

        <!-- Dialog de añadir línea -->
        <v-dialog v-model="product_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Descripción del producto
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="linea.descripcion"
                                type="text"
                                label="Descripción del producto"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="success"
                        large
                        @click="
                            addLinea();
                            product_dialog = false;
                        "
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de editar línea -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="linea.articulo"
                                type="text"
                                label="Artículo"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="linea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="linea.precio"
                                    type="number"
                                    label="Precio unitario"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>

                        <v-col cols="12">
                            <div class="spacing">
                                <v-text-field
                                    v-model="linea.descripcion"
                                    label="Descripción"
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-model="linea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="linea.tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="linea.iva_id"
                                :items="ivas"
                                item-text="descripcion"
                                item-value="id"
                                label="IVA (%)"
                                :rules="required_val"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DialogLibroDiario
            v-model="asiento_dialog"
            :id_factura_entrante="factura.id"
            :id_proveedor="factura.id_proveedor"
            :extra="factura"
        ></DialogLibroDiario>
    </v-container>
</template>

<script>
import proveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";
import { debounce } from "../../../helpers";
import DialogLibroDiario from "../../libroDiario/componentes/DialogLibroDiario.vue";
import ProductosCompraSelect from "../../../components/general/ProductosCompraSelect.vue";
import { currentDay } from "../../../components/general/DateFunctions";
import { rules } from "../../../rules";
import dynamicSelectVue from "../../../components/general/dynamicSelect.vue";
import MetodosDePagoSelect from "../../../components/general/MetodosDePagoSelect.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        DialogLibroDiario,
        proveedoresSelectVue,
        ProductosCompraSelect,
        dynamicSelectVue,
        MetodosDePagoSelect,
    },
    data() {
        return {
            rules: rules,
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            required_val_0: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
                (v) => v != 0 || "El campo no puede ser 0",
            ],

            validFormProveedor: true,

            product_dialog: false,
            dialog: false,
            delete_dialog: false,
            asiento_dialog: false,

            factura: {
                id: null,
                nro_proveedor: null,
                albaranes: [],
                lineas: [],
                id_proveedor: null,
                observaciones: "",
                observaciones_internas: "",
                id_metodo_pago: null,
                proveedor: {},
                fecha: currentDay(),
                fecha_vencimiento: [],
                porcentaje_retencion: 0,
                importe_retencion: 0,
                total: 0,
            },
            headers: [
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Precio unidad", value: "precio", sortable: false },
                { text: "Subtotal", value: "subtotal", sortable: false },
                { text: "Iva (%)", value: "iva.descripcion", sortable: false },
                { text: "Descuento", value: "dcto", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            tipo_linea: 0,
            linea: {
                id_albaran: null,
                tipo: 0,
                id: null,
                id_producto_compra: null,
                descripcion: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                total: null,
                precio_unidad: null,
                iva_id: null,
            },

            productos: [],
            metodos_pagos: [],
            productos_compra: [],
            productos_compra_busqueda: [],
            selectedProductoCompraLinea: null,
            searchProductoCompra: "",
            loadingProductosCompra: false,
            ivas: [],
            albaranes: [],

            proveedor: {
                id: null,
                nombre: "",
                nombre_fiscal: "",
                cif: "",
                telefono: "",
                direccion: "",
                cp: "",
                poblacion: "",
                provincia: "",
                pais: "",
                observaciones: "",
                email: "",
            },

            // proveedores: [],
            /*editlinea: {
                id_albaran: null,
                tipo: 0,
                total: null,
                id: null,
                id_producto_compra: null,
                descripcion: null,
                articulo: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                total: null,
                precio_unidad: null,
                iva_id: null,
            },*/
        };
    },
    watch: {
        linea: {
            handler(val) {
                this.linea.tipo_dcto = 1;
                this.factura.total = this.total;
                this.factura.subtotal = this.subtotal;
                this.factura.valor_iva = this.valor_iva;
            },
            deep: true,
            immediate: true,
        },
        "factura.id_cliente": function (val) {
            this.$store.dispatch("getDataCliente", val);
        },
        "factura.id_proveedor": function (val) {
            if (!val) return;
            const proveedor = this.proveedores.find(
                (element) => element.id == val
            );
            if (!proveedor) return;
            
            // Asegurar que factura.proveedor existe
            if (!this.factura.proveedor) {
                this.factura.proveedor = {};
            }
            
            this.factura.proveedor.direccion = proveedor.direccion;
            this.factura.proveedor.cp = proveedor.cp;
            this.factura.proveedor.provincia = proveedor.provincia;
            this.factura.proveedor.poblacion = proveedor.poblacion;
            this.getAlbaranes();
        },
        "factura.id_pedido": function (val) {
            this.$store.dispatch("getLineas", val);
        },
        "factura.plazos_pago": debounce(function (val) {
            if (this.factura.fecha_vencimiento.length == 0) {
                for (let i = 0; i < val; i++) {
                    this.factura.fecha_vencimiento.push({
                        fecha: currentDay(),
                    });
                }
            } else {
                const num = val - this.factura.fecha_vencimiento.length;

                if (num > 0) {
                    for (let i = 0; i < num; i++) {
                        this.factura.fecha_vencimiento.push({
                            fecha: currentDay(),
                        });
                    }
                } else {
                    for (let i = num; i < 0; i++) {
                        this.factura.fecha_vencimiento.pop();
                    }
                }
            }
        }, 500),
        "linea.tipo": function (val) {
            this.linea.id_albaran = null;
            this.linea.id_producto_compra = null;
        },
        "linea.id_albaran": {
            handler(val) {
                this.updateAlbaran(this.linea, val);
            },
            immediate: true,
        },
        // Recalcular retención cuando cambia el subtotal
        subtotal: {
            handler() {
                this.actualizarRetencionYTotal();
            },
            immediate: false
        },
        // Recalcular total con IVA al añadir, quitar o cambiar líneas
        "factura.lineas": {
            handler() {
                this.$nextTick(() => this.actualizarTotal());
            },
            deep: true
        },
        // Recalcular retención cuando cambia el porcentaje
        "factura.porcentaje_retencion": {
            handler() {
                this.actualizarRetencionYTotal();
            },
            immediate: false
        },
        // Actualizar el total cuando cambia el importe de retención
        "factura.importe_retencion": {
            handler() {
                this.actualizarTotal();
            },
            immediate: false
        },
        searchProductoCompra: debounce(function (val) {
            this.buscarProductosCompra(val);
        }, 350),
    },
    async created() {
        this.getAlbaranes();
        this.$store.dispatch("getProvincias", this);

        // Espera a que getIva() termine antes de continuar
        await this.getIva();

        if (this.$route.query.id) {
            this.getFactura(this.$route.query.id);
        }

        // si el estado o es null ni un array vacio carga la data de facturas en funcion de el
        if (this.state_albaranes.length > 0) {
            await this.setDataFactura();
        }
    },
    methods: {
        // Factura
        getFactura(id) {
            let url =
                this.$route.meta.nota == 1
                    ? `api/notas/${id}`
                    : `api/get-factura-entrante/${id}`;
            let me = this;
            axios.get(url).then(
                (res) => {
                    this.factura = res.data.data;
                    
                    // Inicializar objeto proveedor si no existe
                    if (!this.factura.proveedor) {
                        this.factura.proveedor = {};
                    }
                    
                    // Inicializar campos de retención si no existen
                    if (!this.factura.porcentaje_retencion) {
                        this.factura.porcentaje_retencion = 0;
                    }
                    if (!this.factura.importe_retencion) {
                        this.factura.importe_retencion = 0;
                    }

                    if (this.$route.meta.nota == 1) {
                        let lineas_array = [];
                        let i = 0;
                        // console.log('factura', this.factura);
                        // console.log('lineas antes', this.factura.lineas);
                        this.factura.albaranes.forEach((albaran) => {
                            albaran.lineas.forEach((linea) => {
                                lineas_array[i] = linea;
                                i++;
                            });
                        });
                        this.factura.lineas = lineas_array;
                        this.factura.id_metodo_pago =
                            this.$route.meta.nota == 1 ? 3 : null;
                    }

                    // console.log('lineas despues', this.factura.lineas);
                    
                    // Calcular retención después de cargar la factura
                    this.$nextTick(() => {
                        this.actualizarRetencionYTotal();
                    });
                },
                (res) => {}
            );
        },
        saveFactura() {
            let url =
                this.$route.meta.nota == 1
                    ? "api/generar-nota"
                    : "api/save-factura-entrante";
            let url2 =
                this.$route.meta.nota == 1
                    ? "lista-notas-proveedores"
                    : "lista-facturas-entrante";
            axios
                .post(url, this.factura)
                .then((res) => {
                    this.$router.push(url2);
                })
                .catch((error) => {
                    const data = error.response?.data;
                    const msg = data?.mensaje || data?.error || "Algo salió mal";
                    this.$custom_error(msg);
                });
        },
        // Función auxiliar para actualizar retención y total (el total a pagar puede ser negativo, ej. devolución)
        actualizarRetencionYTotal() {
            const porcentaje = parseFloat(this.factura.porcentaje_retencion) || 0;
            const subtotal = parseFloat(this.subtotal) || 0;

            let nuevoImporte = 0;
            if (porcentaje > 0 && subtotal > 0) {
                const importe = (subtotal * porcentaje) / 100;
                nuevoImporte = Math.round(importe * 100) / 100;
            }

            this.factura.importe_retencion = nuevoImporte;
            this.actualizarTotal();
        },
        // Función auxiliar para actualizar solo el total
        actualizarTotal() {
            const subtotal = parseFloat(this.subtotal) || 0;
            const iva = parseFloat(this.factura.iva) || 0;
            const retencion = parseFloat(this.factura.importe_retencion) || 0;
            const totalCalculado = subtotal + iva - retencion;
            this.factura.total = Math.round(totalCalculado * 100) / 100;
            this.$forceUpdate();
        },
        // Establecer la data de la factura segun la data enviada en el state del route desde "facturacion"
        async setDataFactura() {
            this.factura.id_proveedor = this.state_albaranes[0].id_proveedor;
            this.factura.proveedor = this.state_albaranes[0].proveedor;

            for (const element of this.state_albaranes) {
                // Use this.$set for nested properties
                this.$set(this.linea, "id_albaran", element.id);
                this.linea.precio = element.importe;

                // Espera a que el watcher y selectOrdenCliente terminen
                await this.updateAlbaran(this.linea, this.linea.id_albaran);

                // Luego añade la línea
                await this.addLinea();
            }
        },

        buscarProductosCompra(search) {
            this.loadingProductosCompra = true;
            const params = { amount: 25, page: 1 };
            if (search && String(search).trim()) params.search = String(search).trim();
            axios
                .get("api/get-productos-compra", { params })
                .then((res) => {
                    const raw = res.data.success?.data;
                    this.productos_compra_busqueda = Array.isArray(raw) ? raw : (raw?.data || []);
                })
                .catch(() => {
                    this.productos_compra_busqueda = [];
                })
                .finally(() => {
                    this.loadingProductosCompra = false;
                });
        },
        onProductoCompraSelect(item) {
            if (!item || !item.id) return;
            this.linea.id_producto_compra = item.id;
            this.linea.descripcion = item.nombre || this.linea.descripcion;
            const precio = item.precio != null && item.precio !== "" ? parseFloat(item.precio) : null;
            if (precio !== null && !isNaN(precio)) this.linea.precio = precio;
            // IVA: usar id_iva del producto si viene; si no, buscar por descripción (iva) en la lista de IVAs
            if (item.id_iva != null && item.id_iva !== "") {
                this.linea.iva_id = item.id_iva;
            } else if (item.iva != null && this.ivas && this.ivas.length) {
                const ivaEncontrado = this.ivas.find(
                    (e) => String(e.descripcion) === String(item.iva) || String(e.id) === String(item.iva)
                );
                if (ivaEncontrado) this.linea.iva_id = ivaEncontrado.id;
            }
        },
        onFocusProductoCompra() {
            if (this.productos_compra_busqueda.length === 0) this.buscarProductosCompra("");
        },
        // Lineas
        getLinea(linea_l) {
            let linea = linea_l;

            linea.subtotal = linea.precio * linea.cantidad;

            if (linea.tipo_dcto == 0) {
                linea.dcto = (linea.precio * linea.cantidad * linea.dcto) / 100;
                linea.tipo_dcto = 1;
            }

            linea.iva = this.ivas.find((ele) => ele.id == linea.iva_id);

            linea.total = linea.subtotal - linea.dcto;

            return JSON.parse(JSON.stringify(linea));
        },
        async addLinea() {
            this.linea.tipo_dcto = 1;
            if (this.linea.id_albaran != null) {
                // const albaran = this.albaranes.find(
                //     (alb) => alb.id == this.linea.id_albaran
                // );
                let albaran = null;
                if (this.state_albaranes.length > 0) {
                    albaran = this.state_albaranes.find(
                        (ele) => ele.id == this.linea.id_albaran
                    );
                } else {
                    albaran = this.albaranes.find(
                        (ele) => ele.id == this.linea.id_albaran
                    );
                }

                let result = {};
                albaran.lineas.forEach((linea) => {
                    if (result[linea.iva_id] == null) result[linea.iva_id] = 0;
                    result[linea.iva_id] += linea.total;
                });
                this.ivas.forEach((ele) => {
                    if (result[ele.id] != null) {
                        const line = JSON.parse(JSON.stringify(this.linea));
                        line.precio = result[ele.id];
                        line.iva_id = ele.id;
                        line.iva = ele;
                        this.factura.lineas.push(this.getLinea(line));
                    }
                });

                // console.log('factura.lineas', this.factura.lineas);
            } else {
                this.factura.lineas.push(this.getLinea(this.linea));
            }
            this.clearLinea();
        },
        openEditDialog(item) {
            // this.editlinea = JSON.parse(JSON.stringify(item));
            // this.editlinea.index = this.factura.lineas.indexOf(item);

            this.linea = { ...item };
            this.linea.index = this.factura.lineas.indexOf(item);
            this.dialog = true;
        },
        Edit() {
            let index = this.linea.index;
            let linea = this.getLinea(this.linea);
            this.factura.lineas[index] = JSON.parse(JSON.stringify(linea));
            this.factura.lineas = JSON.parse(
                JSON.stringify(this.factura.lineas)
            );
            this.dialog = false;
        },
        openDeleteDialog(item) {
            this.linea = item;
            this.delete_dialog = true;
        },
        deleteLinea() {
            // let index = this.factura.lineas.indexOf(this.editlinea);
            let index = this.factura.lineas.indexOf(this.linea);

            this.factura.lineas.splice(index, 1);
            this.delete_dialog = false;
        },
        clearLinea() {
            this.selectedProductoCompraLinea = null;
            this.searchProductoCompra = "";
            this.linea = {
                id_albaran: null,
                tipo: 0,
                id: null,
                descripcion: null,
                id_producto_compra: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                total: null,
                precio_unidad: null,
                iva_id: null,
            };
        },

        // Albaranes
        getAlbaran(items) {
            let lineas_array = [];
            let albaran = null;
            let k = 0;
            // Al seleccionar los albaranes.
            // lo primero que debo hacer es verificar si existe dentro de las lineas

            for (let j = 0; j < items.length; j++) {
                let encontrado = false;
                for (let i = 0; i < this.factura.lineas.length; i++) {
                    // Si existe una coincidencia creo una copia del array linea
                    if (items[j] == this.factura.lineas[i].id_albaran) {
                        lineas_array[k] = this.factura.lineas[i];
                        k++;
                        encontrado = true;
                    }
                }
                albaran = this.albaranes.find(
                    (element) => element.id == items[j]
                );
                // Si no existe la coincidencia, busco dentro de albaranes
                if (!encontrado) {
                    // Y agrego las lineas faltantes de ese albaran
                    albaran.lineas.forEach((linea) => {
                        lineas_array[k] = linea;
                        k++;
                    });
                }
                if (this.$route.meta.nota == 1) {
                    // Si es una nota, envío los albaranes como un objeto
                    this.factura.albaranes[j] = albaran;
                }
            }
            // Por último, la copia de las lineas la convierto en la original
            this.factura.lineas = lineas_array;
        },
        async getAlbaranes() {
            if (this.factura.id_proveedor) {
                try {
                    const resp = await axios.get(
                        `api/get-albaranes?amount=-1&estado=2&id_proveedor=${this.factura.id_proveedor}`
                    );
                    // console.log('albaranes', resp);
                    // console.log(resp);
                    this.albaranes = resp.data.success.data;
                    // console.log('variable albaranes', this.albaranes);
                } catch (ex) {
                    // console.log(ex);
                }
            } else {
                this.albaranes = [];
            }
        },
        async updateAlbaran(linea, val) {
            if (val != null) {
                // const albaran = this.albaranes.find((alb) => alb.id == val);
                let albaran = null;

                if (this.state_albaranes.length > 0) {
                    albaran = this.state_albaranes.find((ele) => ele.id == val);
                } else {
                    albaran = this.albaranes.find((ele) => ele.id == val);
                }

                if (!albaran) {
                    console.log("Albarán no encontrado");
                    return;
                }

                linea.cantidad = 1;
                linea.precio = albaran.importe;
                linea.descripcion = albaran.nro;
            }
        },
        remove(item) {
            console.log("albaranes", this.factura.albaranes);

            const index = this.factura.albaranes.indexOf(item.id);
            if (index >= 0) this.factura.albaranes.splice(index, 1);
        },

        // Funciones de dynamicSelect proveedor
        saveProveedor() {
            this.$refs.formProveedor.validate();
            if (!this.validFormProveedor) return;
            axios
                .post("api/save-proveedor", this.proveedor)
                .then((res) => {
                    this.$refs.dynamicSelectProveedor.closeDialog();
                    this.$toast.sucs("Proveedor guardado con éxito");
                    this.clearProveedor();
                    this.$store.dispatch("getProveedores", this);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        deleteProveedor(id) {
            axios
                .post(`api/delete-proveedor`, { id: id })
                .then((res) => {
                    this.$toast.sucs("Proveedor eliminado con éxito");
                    this.$store.dispatch("getProveedores", this);
                    this.clearProveedor();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getProveedorId(id) {
            if (id != null) {
                axios
                    .get(`api/getproveedor/${id}`)
                    .then((res) => {
                        this.proveedor = res.data;
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        changeProveedor(id) {
            // Solo actualizar el proveedor; no recargar la factura (eso
            // sobrescribía id_proveedor con el valor guardado en BD).
            if (id != null) {
                this.factura.id_proveedor = id;
            }
        },
        clearProveedor() {
            this.proveedor = {
                id: null,
                nombre: "",
                nombre_fiscal: "",
                cif: "",
                telefono: "",
                direccion: "",
                cp: "",
                poblacion: "",
                provincia: "",
                pais: "",
                observaciones: "",
                email: "",
            };
        },

        openAsiento() {
            this.asiento_dialog = true;
        },

        // Metodos generales
        async getIva() {
            try {
                const res = await axios.get(`api/get-iva`);
                this.ivas = res.data.success;
            } catch (error) {
                console.error("Error al obtener IVA", error);
            }
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },

        formatPrice,

        // En desuso
        openDescripcion() {
            if (!this.$refs.linea_form.validate()) return;
            this.linea.descripcion = this.productos.find(
                (element) => element.id == this.linea.id_producto_compra
            ).descripcion;

            this.product_dialog = true;
        },
        /*formatNumber(number) {
            if (number == null) return "null";
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        getProveedores() {
            axios.get(`api/get-proveedores`).then(
                (res) => {
                    this.proveedores = res.data.data;
                },
                (res) => {}
            );
        },
        proveedorSelected(id) {
            let proveedor_selected = this.proveedores.find(
                (element) => element.id === id
            );

            this.linea.tipo_dcto = proveedor_selected.tipo_dcto ?? 1;
            this.linea.dcto = proveedor_selected.dcto ?? 0;
        },*/
    },
    computed: {
        subtotal() {
            let total = 0;
            this.factura.lineas.forEach((elemento) => {
                total += elemento.total;
            });
            this.factura.subtotal = total;
            return total;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        iva() {
            let ivas = {};
            this.factura.lineas.forEach((elemento) => {
                let iva_linea = 0;
                // let total_sin_iva = 0;
                let total = 0;
                let iva = this.ivas.find(
                    (element) => element.id == elemento.iva_id
                )?.descripcion;

                // total_sin_iva = elemento.total/(1 + parseInt(iva)/100);
                total += elemento.total;
                iva_linea = (total * parseInt(iva)) / 100;
                // elemento.iva = iva;

                // Agregar el IVA al tipo de IVA correspondiente en el objeto ivas
                if (iva != 0) {
                    if (iva in ivas) {
                        ivas[iva] += iva_linea;
                    } else {
                        ivas[iva] = iva_linea;
                    }
                }
            });

            // Sumar los valores de los totales de IVA en el objeto presupuesto.ivas
            let totalIva = Object.values(ivas).reduce(
                (total, iva) => total + iva,
                0
            );
            this.factura.iva = totalIva;
            return ivas;
        },

        total() {
            // Siempre calcular en tiempo real: subtotal + IVA - retención (para que se actualice al añadir/editar líneas)
            const subtotal = parseFloat(this.subtotal) || 0;
            const iva = parseFloat(this.factura.iva) || 0;
            const retencion = parseFloat(this.factura.importe_retencion) || 0;
            const totalCalculado = subtotal + iva - retencion;
            return Math.round(totalCalculado * 100) / 100;
        },
        totalAPagar() {
            // Alias para mantener compatibilidad, pero ahora total() ya incluye la retención
            return this.total;
        },
        // state de vuex seteado desde "facturacion" que trae las ordenes para crear la factura
        state_albaranes() {
            const data = this.$store.getters.getAlbaranesData;
            return data;
        },

        provincias() {
            return this.$store.getters.getprovincias;
        },
        proveedores() {
            return this.$store.getters.getproveedores;
        },

        /*valor_iva() {
            let valor_iva = 0;
            let total = 0;
            this.factura.lineas.forEach((elemento) => {
                if (elemento.iva != null) {
                    total =
                        (elemento.total *
                            parseInt(elemento.iva?.descripcion ?? 0)) /
                        100;
                    valor_iva += total;
                } else {
                    const iva = this.iva.find(
                        (iva) => iva.id == elemento.iva_id
                    );
                    total =
                        (elemento.total * parseInt(iva?.descripcion ?? 0)) /
                        100;
                    valor_iva += total;
                }
            });
            this.factura.valor_iva = valor_iva;
            return valor_iva;
        },
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;
            if (this.presupuesto?.clientela != null) {
                clientes_temp.push(this.presupuesto.clientela);
            }
            return clientes_temp;
        },
        pedidos() {
            /////console.log("siva");
            let pedidos_temp = this.$store.getters.getpedidos;

            return pedidos_temp;
        },
        lineas_pedido() {
            let pedidos_temp = this.$store.getters.getlineaspedido;

            return pedidos_temp;
        },*/
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
</style>
